export default "assets/user-ab473320.svg";